import _ from "underscore";
import resolve from "ioc/resolve";
import Media from "webutils/media/media";
import fabric from "emun.on-demand/lib/fabric";
import utils from "emun.on-demand/lib/util";
import DesignLayer from "emun.on-demand/lib/design-layer";
import libConfig from "emun.on-demand/lib/_config";
import $pageConfig from "webutils/services/page-config";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import webcolors from "webcolors/webcolors";
import config from "emun.on-demand/_fabric.config";
import httpPoller from "webutils/http-poller.service";

const maxStates = 25;
const loom32DesignPath = "emun-on-demand.s3.amazonaws.com/designs/mw141";
const loom32ImagePath = "emun-on-demand.s3.amazonaws.com/images/mw141";

class Design extends Media {
  constructor(dto, hydrate) {
    super(dto);
    let d = this;

    //properties
    d.status = "constructing";
    d.overscan = 0;
    d.activations = 0;
    d.background = "";
    d.objects = [];
    d.overlays = [];
    d.underlays = [];
    d.perspectives = [];
    d.history = [];
    d.historyIndex = false;
    d.recording = false;
    d.dirty = false;
    Object.assign(d, dto);
    if (hydrate !== false) {
      d.$hydrated = d.hydrate().then(() => {
        if (!d.perspectives || !d.perspectives.length)
          d.perspectives = (d.overlays || []).filter(
            (o) => o.canDesign !== false
          );
        if (d.overlayImage && d.overlayImage.src)
          d.perspectives.push({
            canDesign: true,
            isProductImage: true,
            permanent: true,
            label: "Overlay Image",
            media: new Media({ url: d.overlayImage.src }),
            x: d.overlayImage.x || 0,
            y: d.overlayImage.y || 0,
            width: d.overlayImage.width,
            height: d.overlayImage.height,
          });
        ////console.info('d.perspectives', d.perspectives, d.overlays);
        //d.onHydrated();
        ////console.warn('d.perspectives', d.perspectives, d.overlays);
      });
    } else {
      d.$hydrated = resolve("$q").when(true);
    }
    //done
    resolve("$rootScope").$emit("designReady", { design: d });
  }

  static get(designId, hydrate) {
    //console.warn('get.designId', designId);
    return ServiceBus.read(
      `QueryMedia/${+designId ? designId : "euid/" + designId}.json?Context=All`
    ).then(
      (r) => r.data.results.length && new Design(r.data.results[0], hydrate)
    );
  }

  static fromArea(a, b, c, e, f, g) {
    let d = (a.design = new Design(Object.assign(a.design, b, c, e, f, g)));
    d.areaId = a.euid;
    d.area = a.label;
    d.height = a.height;
    d.width = a.width;
    d.overlays = a.overlays.map((m) =>
      Object.assign({ isOverlay: true, type: "overlay" }, m)
    );
    d.underlays = a.underlays.map((m) =>
      Object.assign({ isUnderlay: true, type: "underlay" }, m)
    );
    d.supplierCode = a.supplierCode;
    d.overscan = d.bleed = d.bleedLine = a.bleedLine;
    d.setPerspectives(
      d.overlays.concat(d.underlays).filter((o) => o.canDesign !== false)
    );
    d.backgroundColor = d.background = d.areaBackgroundColor =
      a.backgroundColor;
    return d;
  }

  static scrub(objects, level) {
    if (!level) level = 0;
    (objects || []).forEach((o) => {
      //if(o.layerId && !o.layer) o.layer = utils.splatName(o.layerId);
      if (o.type === "text") {
        o.perPixelTargetFind = false;
        o.text = "" + (o.text || "");
        if (o.fontFamily) o.fontFamily = o.fontFamily.replace(/'"/gi, "");
      }
      if (o.type === "group") {
        delete o.fill;
      }
      if (o.type === "image") {
        ////console.log('scrubImage', o.type, o.oldFill, level, o);
        let isDataUrl = o.src.startsWith("data:");
        let isLoom32Design = o.src.indexOf(loom32DesignPath) >= 0;
        let isLoom32Image = o.src.indexOf(loom32ImagePath) >= 0;
        let layer = utils.splatName(o.layerId);
        o.originalSrc = o.src;
        o.src = o.src.replace(
          "http://emun-on-demand.s3-website-us-east-1.",
          "https://emun-on-demand.s3."
        );
        o.crossOrigin = "anonymous";
        if (isLoom32Image) o.src = o.src.replace("/hires", "/thumbnail");
        else if (!isLoom32Design && !isDataUrl && layer.isImage)
          o.src = Media.getUrl(o.src, "medium.png");
        if (
          layer.isColor &&
          o.fill &&
          o.oldFill &&
          o.fill !== o.oldFill &&
          _.isString(o.fill)
        )
          o.filters = [
            new fabric.Image.filters.Tint({
              color: o.fill,
              opacity: 1,
            }),
          ];
      } else {
        if (o.fill && o.fill.indexOf && o.fill.indexOf("rgb") === 0) {
          o.fill = webcolors.rgbToHex(o.fill);
        }
      }
      Design.scrub(o.objects, level + 1);
    });
  }

  static unscrub(objects) {
    (objects || []).forEach((o) => {
      delete o.clipTo;
      if (o.type === "image") {
        if (o.originalSrc) {
          o.src = o.originalSrc;
          delete o.originalSrc;
        }
      } else if (o.type === "text") {
        o.text = "" + (o.text || "");
      }
      Design.unscrub(o.objects);
    });
  }

  activate(designer) {
    const d = this;
    d.status = "activating";
    d.activations++;
    d.recording = true;
    //return;
    d.$$designer = designer;
    d.$$canvas = designer.$fc;
  }

  deactivate() {
    const design = this;
    design.status = "inactive";
    design.recording = false;
    design.$$designer = null;
    design.$$canvas = null;
  }

  validate() {
    const $q = resolve("$q");
    const design = this;
    let args = { design };

    let validatePromises = $q.when(1);

    design.validationMessages = [];
    libConfig.confirmations.forEach(
      (c) => (validatePromises = validatePromises.then(() => c.open(args)))
    );

    //console.info('design.validatePromises', design, validatePromises);
    return validatePromises;
  }

  setPerspectives(perspectives) {
    const d = this;
    d.perspectives = perspectives;
    // d.perspective = d.perspectives[0];
  }

  getPayloadForSaving(replacePredecessor) {
    const $cart = resolve("$cart"); //smelly
    let inc = (p) => !p.ignore && p.isProductImage;
    let d = this;
    let overlays = d.overlays.filter(inc);
    let underlays = d.underlays.filter(inc);
    if (overlays.concat(underlays).length === 0)
      overlays = d.perspectives.filter(inc);
    let payload = {
      predecessorId: d.id,
      replacePredecessor,
      label: d.label,
      realm: d.realm, //???
      productId: d.productId,
      description: d.description,
      tags: d.tags,
      width: d.width,
      height: d.height,
      background: d.background,
      backgroundImage: d.backgroundImage,
      objects: d.objects,
      saveJson: d.saveJson,
      overlays,
      underlays,
      tags: {},
    };
    if (overlays.length && overlays[0].permanent) {
      payload.saveJson = true;
      payload.overlayImage = {
        type: "image",
        x: 0,
        y: 0,
        src: overlays[0].media.url,
        media: overlays[0].media,
        overlay: overlays[0],
        euid: overlays[0].euid,
        width: d.width,
        height: d.height,
      };
      payload.overlays = [];
    }
    if (
      $cart.businessModel === "Wholesale" &&
      $cart.purchaser &&
      $cart.purchaser.id
    )
      payload.tags["$RetailerId"] = [$cart.purchaser.id];

    return payload;
  }

  loadValidationResult() {
    const d = this;
    const url = d.designUrl().replace("design.json", "validationResult.json");
    return httpPoller({ url, get: true }).then(
      (res) => (d.validationResult = res.data.validationResult)
    );
  }

  assignPayload(payload) {
    const d = this;
    d.background = payload.background;
    d.objects = payload.objects;
    d.backgroundImage = payload.backgroundImage;
    d.backgroundColor = payload.backgroundColor;
    d.overlayImage = payload.overlayImage;
    d.overlayColor = payload.overlayColor;
    if (!d.overlays || !d.overlays.length) d.overlays = payload.overlays || [];
    d.overlays.forEach((m) => (m.type = "overlay"));
    if (!d.underlays || !d.underlays.length)
      d.underlays = payload.underlays || [];
    d.underlays.forEach((m) => (m.type = "underlay"));
    if (!d.perspectives || !d.perspectives.length)
      d.setPerspectives(
        d.overlays.concat(d.underlays).filter((o) => o.canDesign !== false)
      );
    (d.objects || []).forEach((o) => {
      if (o.src) {
        o.src = o.src.replace(
          "http://emun-on-demand.s3-website-us-east-1.",
          "https://emun-on-demand.s3."
        );
        console.debug(o.src, o, this);
      }
    });
  }

  hydrate() {
    const design = this;
    return resolve("$http")
      .get(design.designUrl())
      .then((res) => {
        if (res.data.payload) {
          //loom32 artificat
          Object.assign(res.data, res.data.payload);
        }
        if (!design.width || !design.height) {
          if (res.data.width || res.data.height) {
            design.width = res.data.width;
            design.height = res.data.height;
            design.assignPayload(res.data);
          } else {
            fabric.util.enlivenObjects(res.data.objects, (members) => {
              let group = new fabric.Group(members);
              design.width = group.width;
              design.height = group.height;
              design.assignPayload(res.data);
            });
          }
        } else {
          design.assignPayload(res.data);
        }
      });
  }

  load(id) {
    const d = this;
    return d.bus
      .send(`QueryMedia/${id || d.id}.json`)
      .then(
        (response) => {
          Object.assign(d, response.data);
          //console.debug('design loaded!', response);
        },
        (response) => {
          //console.error('media did not load', response);
        }
      )
      .finally((args) => {
        d.status = "ready";
        d.dirty = false;
      });
  }

  validateAndSave(replacePredecessor) {
    let d = this;
    return d.validate().then(() => d.save(replacePredecessor));
  }

  save(replacePredecessor) {
    let $q = resolve("$q");
    let d = this;
    let isLoom32Design = d.url.indexOf(loom32DesignPath) >= 0;
    if (d.status !== "ready" && d.status !== "inactive")
      return $q.reject(false);
    //if (!d.canUndo() && !isLoom32Design) return $q.when(d);
    //console.info('design.save', d);

    d.status = "saving";
    d.unscrub();
    let request = d.getPayloadForSaving(replacePredecessor);
    //console.info('design.request', request);
    return d.bus
      .send("CreateDesign.json", request)
      .then(
        (response) => {
          d.id = response.data.id;
          d.euid = response.data.euid;
          d.url = response.data.url;
          d.images = response.data.images;
          d.overlayImages = response.data.overlayImages;
          d.underlayImages = response.data.underlayImages;
          //console.debug('designSaved!', response);
          return response;
        },
        (response) => {
          //console.error('designSaveFailed', response);
        }
      )
      .finally((args) => {
        d.status = "ready";
        d.dirty = false;
      });
  }

  revive(payload) {
    let design = this;
    design.objects = JSON.parse(payload);
    resolve("$rootScope").$emit("designRevived", { design, payload });
    //console.warn('designRevived', design.objects);
    // TODO: have designer listen and restore this payload
    //design.$$canvas.loadFromJSON(payload, () => design.$$designer.render())
  }

  setFirst($$first) {
    let design = this;
    //console.warn('design.$$first', $$first, design.$$first);
    design.$$first = $$first;
    design.history = [];
    design.historyIndex = false;
  }

  reset() {
    let design = this;
    design.history = [];
    design.historyIndex = false;
    resolve("$rootScope").$emit("designRevived", {
      design,
      payload: design.$$first,
    });
  }

  clear() {
    let design = this;
    design.history = [];
    design.historyIndex = false;
    resolve("$rootScope").$emit("designRevived", {
      design,
      payload: { objects: [] },
    });
  }

  pause() {
    this.recording = "paused";
  }

  scrub() {
    Design.scrub(this.objects);
  }

  unscrub() {
    Design.unscrub(this.objects);
  }

  record(payload, force) {
    let d = this;
    if (d.recording === "paused" && !force) return false;
    if (d.recording) {
      delete payload.overlayImage;
      Design.unscrub(payload.objects);
      let json = JSON.stringify(payload);
      if (
        json !=
        d.history[
          d.historyIndex === false ? d.history.length - 1 : d.historyIndex
        ]
      ) {
        d.history.length >= maxStates && d.history.shift();
        if (d.historyIndex !== false) {
          d.history.splice(d.historyIndex + 1, d.history.length);
        }
        d.objects = payload.objects;
        d.background = payload.background; // and background?
        d.history.push(json);
        d.historyIndex = false;
        //$scope.$$phase || $scope.$digest();
      }
    }
    d.recording = true;
  }

  canUndo() {
    let d = this;
    return (
      d.history.length > 1 && (d.historyIndex === false || d.historyIndex > 0)
    );
  }

  canRedo() {
    let d = this;
    return (
      d.history.length > 1 &&
      d.historyIndex !== false &&
      d.historyIndex < d.history.length - 1
    );
  }

  undo() {
    let d = this;
    if (d.canUndo()) {
      d.recording = false;
      if (d.historyIndex === false) {
        d.historyIndex = d.history.length - 2;
      } else {
        d.historyIndex--;
      }
      let json = d.history[d.historyIndex];
      d.revive(json);
      return json;
    }
    return false;
  }

  redo() {
    let d = this;
    if (d.canRedo()) {
      d.recording = false;
      if (d.historyIndex === false) {
        d.historyIndex = d.history.length - 2;
      }
      d.historyIndex++;
      let json = d.history[d.historyIndex];
      d.revive(json);
      return json;
    }
    return false;
  }

  populateWith(src) {
    const trg = this;
    trg.objects = src.objects.map((m) => Object.assign({}, m));
    trg.background = src.background;
  }

  resize(width, height) {
    let d = this;
    d.width = width;
    d.height = height;
    //d.$$designer.activate(d);
  }

  toDataUrl() {
    const design = this;
    const canvas = new fabric.StaticCanvas();
    const deferred = resolve("$q").defer();
    const perspective = design.perspective || design;
    const toDataURL = {
      format: "png",
      multiplier: design.scaled.multiplier,
      width: perspective.width,
      height: perspective.height,
      left: -perspective.x,
      top: -perspective.y,
    };
    const loadFromJSON = {
      overlayImage:
        perspective && perspective.media
          ? {
              type: "image",
              opacity: perspective.opacity || 1,
              height: perspective.height,
              width: perspective.width,
              left: -perspective.x,
              top: -perspective.y,
              url: perspective.media.url,
              src: perspective.media.url,
              crossOrigin: "anonymous",
              // Needed to position overlayImage at 0/0
              originX: "left",
              originY: "top",
            }
          : null,
      backgroundImage: design.backgroundImage,
      objects: design.objects,
    };

    canvas.loadFromJSON(loadFromJSON, () =>
      deferred.resolve(canvas.toDataURL(toDataURL))
    );
    return deferred.promise;
  }

  scale(_designer) {
    const design = this;
    const designer = _designer || design.$designer;
    /// TODO: CPWS if (!designer) return console.warn('no designer', designer);
    /// https://code.angularjs.org/1.5.9/docs/error/ng/cpws ui-carousel

    let perspective = design.perspective || design;
    let constrainTo = designer.constrainTo || 500;
    //console.info('scaleDesign', design, perspective);
    let smallest = fabric.greatestCommonDivisor(perspective);
    //console.log('constrainTo', constrainTo);
    //console.log('designer.$container.clientWidth', designer.$container.clientWidth);
    //console.log('smallest', smallest);
    let clientWidth =
      designer.$container.clientWidth ||
      ($pageConfig.is("lg")
        ? 400
        : $pageConfig.is("md")
        ? 375
        : $pageConfig.is("sm")
        ? 350
        : constrainTo);
    //console.log('clientWidth', clientWidth);
    let largest = {
      width: Math.min(clientWidth - 40, constrainTo),
      height: Math.min($pageConfig.height * 0.75, constrainTo),
    };
    //console.log('largest', largest);
    //normalize it
    largest.width = largest.width - (largest.width % 25);
    largest.height = largest.height - (largest.height % 25);
    let scaled = Object.assign({}, smallest);
    let containMultiplier = utils.getContainScale(perspective, largest);
    while (scaled.width < largest.width && scaled.height < largest.height) {
      scaled.width += smallest.width;
      scaled.height += smallest.height;
    }
    scaled.multiplier = scaled.zoom = scaled.width / perspective.width;
    if (scaled.multiplier > containMultiplier) {
      //console.debug('ceiling breach', containMultiplier, scaled.multiplier)
      // set ceiling
      scaled.multiplier = scaled.zoom = containMultiplier;
      scaled.width = (perspective.width || 0) * containMultiplier;
      scaled.height = (perspective.height || 0) * containMultiplier;
    }
    scaled.overscan =
      (perspective.overscan || design.overscan) * scaled.multiplier;
    scaled.x = (perspective.x || 0) * scaled.multiplier;
    scaled.y = (perspective.y || 0) * scaled.multiplier;
    //console.debug('scaleDesign.scaled', scaled)
    //console.debug('containMultiplier', containMultiplier)

    return scaled;
  }

  renderingImage(size) {
    return $appConfig.renderingImage(this.id, size);
  }

  //events

  onHydrated() {
    //console.info('d.onHydrated local');
  }
}

export default Design;
